<template>
  <div class="div">
    <div class="form border">
      <div class="row p-3">
        <div class="col-md-12">
          <div>
            <div class="page-heading mb-3">Select Report Settings</div>
          </div>
          <div class="border p-2 mt-2">
            <label class="form-label">Select Type:</label>
            <div class="d-flex">
              <div class="form-check d-inline-flex">
                <input
                  class="form-check-input"
                  type="radio"
                  name="reporttype"
                  id="reporttypelogins"
                  v-model="form.is_report_order_type"
                  :value="false"
                />
                <label class="form-check-label" for="reporttype">
                  Logins
                </label>
              </div>

              <div class="form-check d-inline-flex ms-4 ml-4">
                <input
                  class="form-check-input"
                  type="radio"
                  name="reporttype"
                  id="reporttypeorders"
                  v-model="form.is_report_order_type"
                  :value="true"
                />
                <label class="form-check-label" for="reporttype">
                  Orders
                </label>
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Select Date Range:</label>
            <div class="d-flex">
              <div class="col-md-4">
                <label class="form-label" for="startdate"> Start Date: </label>

                <a-date-picker format="MM/DD/YYYY" name="startdate" class="form-control" v-model="sDate" @change="startDate" :allowClear="false" />
              </div>
              <div class="ms-4 col-md-4">
                <label class="form-label" for="enddate"> End Date: </label>
                <a-date-picker format="MM/DD/YYYY" class="form-control" name="enddate" v-model="eDate" @change="endDate" :allowClear="false" />
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Select a client:</label>
            <div class="d-flex">
              <div class="form-check col-md-4">
                <input
                  class="form-check-input"
                  type="radio"
                  name="allclients"
                  id=""
                  v-model="form.is_all_clients_selected"
                  :value="true"
                  @input="allClients"
                />
                <label class="form-check-label" for="allclients">
                  All Clients
                </label>
              </div>

              <div class="form-group ms-4 col-md-4">
                <input class="form-check-input" type="radio" name="allclients" id="" v-model="form.is_all_clients_selected" :value="false" />
                <label class="form-check-label" for="allclients">
                  Selected Clients
                </label>
                <b-select
                  class="form-select form-select-sm mt-2"
                  aria-label=".form-select-sm example"
                  size="5"
                  multiple
                  v-model="form.client_ids"
                  @change="clientSelected"
                >
                  <option v-for="client in this.authorizedClients" :key="client.index" :value="client.clientId">
                    {{ client.clientName }}
                  </option>
                </b-select>
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">What platform types do you wish to include? </label>
            <div class="">
              <div class="form-check mt-1">
                <input class="form-check-input" type="checkbox" value="Desktop" name="platormtype" v-model="form.platform_types" />
                <label class="form-check-label" for="platormtypeweb">
                  Desktop
                </label>
              </div>

              <div class="form-check mt-1">
                <input class="form-check-input" type="checkbox" value="Android" name="platormtype" disabled />
                <label class="form-check-label" for="platormtypeandroid">
                  Android
                </label>
              </div>

              <div class="form-check mt-1">
                <input class="form-check-input" type="checkbox" value="iOS" name="platormtype" disabled />
                <label class="form-check-label" for="platormtypeios">
                  iOS
                </label>
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Filter by user info: </label>
            <div class="row mt-1">
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="firstname" class="form-label">First Name:</label>
                  <input type="text" class="form-control" name="firstname" v-model="form.first_name" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="lastname" class="form-label">Last Name:</label>
                  <input type="text" class="form-control" name="lastname" v-model="form.last_name" />
                </div>
              </div>

              <div class="col-md-8">
                <div class="mb-3">
                  <label for="email" class="form-label">Email:</label>
                  <input type="text" class="form-control" name="email" v-model="form.email" />
                </div>
              </div>
            </div>
          </div>

          <div class="mt-3 border p-2">
            <label class="form-label">Export to Excel: </label>

            <div class="d-flex">
              <div class="form-check d-inline-flex">
                <input class="form-check-input" type="radio" name="excelexport" :value="true" v-model="form.export_to_excel" />
                <label class="form-check-label" for="excelexport"> Yes </label>
              </div>

              <div class="form-check d-inline-flex ms-4 ml-4">
                <input class="form-check-input" type="radio" name="excelexport" :value="false" v-model="form.export_to_excel" />
                <label class="form-check-label" for="excelexport"> No </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-2 ms-4 ml-3">
        <input type="submit" class="btn btn-primary" value="Create Report" @click="onSubmit" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

const eDate = moment();
const sDate = moment().subtract(7, 'd');

export default {
  name: 'LoginsAndOrdersReportForm',
  data() {
    return {
      sDate: this.storeStartDate ?? sDate,
      eDate: this.storeEndDate ?? eDate,
      selectCompanyOptions: [],
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      if (this.form.export_to_excel) {
        this.$store.dispatch('loginsAndOrdersReport/addLoginsOrdersReportExcel', this.form).then(() => {
          if (this.form.email !== '') {
            alert('Email sent successfully.');
          }
          this.form = {
            is_report_order_type: false,
            start_date: sDate + 'T00:00:00.000Z',
            end_date: eDate + 'T23:59:59.000Z',
            is_all_clients_selected: true,
            client_ids: [],
            platform_types: ['Desktop'],
            first_name: '',
            last_name: '',
            email: '',
            export_to_excel: false,
          };
          this.sDate = sDate;
          this.eDate = eDate;
        });
      } else {
        this.$store
          .dispatch('loginsAndOrdersReport/addLoginsOrdersReport', {
            form: this.form,
            params: {
              pg_num: 1,
              pg_size: 10,
            },
          })
          .then(() => {
            if (this.form.is_report_order_type === false) {
              this.$router
                .push({
                  name: 'AdminLoginsReportView',
                  params: {
                    start_date: this.sDate.format('YYYY-MM-DD'),
                    end_date: this.eDate.format('YYYY-MM-DD'),
                    form: this.form,
                  },
                })
                .then(() => {
                  window.scrollTo(0, 0);
                });
            } else {
              this.$router
                .push({
                  name: 'AdminOrdersReportView',
                  params: {
                    start_date: this.sDate.format('YYYY-MM-DD'),
                    end_date: this.eDate.format('YYYY-MM-DD'),
                    form: this.form,
                  },
                })
                .then(() => {
                  window.scrollTo(0, 0);
                });
            }
          })
          .catch((e) => {
            alert(e);
          });
      }
    },
    clientSelected() {
      console.log('triggerd');
      this.form.is_all_clients_selected = false;
    },
    allClients() {
      this.form.client_ids = [];
    },
  },
  computed: {
    authorizedClients() {
      return this.$store.getters['loginsAndOrdersReport/getAuthorizedClients'];
    },
    form() {
      return this.$store.state.loginsAndOrdersReport.form;
    },
    startDate() {
      var jsObj = JSON.parse(JSON.stringify(this.sDate.format('YYYY-MM-DD')));
      var dt = new Date(jsObj);
      var newDate = dt.toISOString();
      this.form.start_date = newDate;
      return this.form.start_date;
    },
    endDate() {
      let newDate = this.eDate.format('YYYY-MM-DD') + 'T23:59:59Z';
      this.form.end_date = newDate;
      return this.form.end_date;
    },
    ...mapState({
      storeStartDate: (state) => state.loginsAndOrdersReport.sDate,
      storeEndDate: (state) => state.loginsAndOrdersReport.eDate,
    }),
  },
  watch: {
    sDate(newVal, oldVal) {
      this.$store.dispatch('loginsAndOrdersReport/setStartDate', newVal);
    },
    eDate(newVal, oldVal) {
      this.$store.dispatch('loginsAndOrdersReport/setEndDate', newVal);
    },
  },
  mounted() {
    this.$store.dispatch('loginsAndOrdersReport/fetchAuthorizedClients');
    this.sDate = this.storeStartDate ?? sDate;
    this.eDate = this.storeEndDate ?? eDate;
  },
};
</script>

<style scoped>
.border {
  border-radius: 5px;
}

.page-heading {
  font-size: 20px;
  font-weight: 500;
}
</style>
